import React, { Component } from 'react';
import { hideModal, MODAL_QUESTION_TRASHED_RECOVERY } from '../../../modules/modals';
import { Field, reduxForm, getFormValues, formValueSelector  } from 'redux-form'
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { required, email } from 'redux-form-validators'
import InputField from '../../helpers/Fields/InputField';
import SelectFieldAnt from '../../helpers/Fields/SelectFieldAnt';


class RecoveryModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_QUESTION_TRASHED_RECOVERY});

  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleRecoveryQuizQuestion"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  submit = async(values) => {
  
    try {
      const {formatMessage} = this.context;
      const { recoveryQuestion, question_id } = this.props;
      await recoveryQuestion(question_id, values);
      this.handleClose();
      toastr.success(formatMessage('msgNotificationRecoveryQuestion'), formatMessage('msgNotificationQuizQuestionRecovery'))
    } catch (error) {
      console.log("RecoveryModal -> submit -> error", error)
      
    }
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex, handleSubmit, subjects, categories, subcategories, subject_id, category_id } = this.props;
    
    const subject_opt = subjects.filter(_i => _i.status == 1).map(_i => ({title: _i.name, value: _i.id}));
    const categories_opt = categories.filter(_i => _i.status == 1 && _i.branch_id == subject_id).map(_i => ({title: _i.name, value: _i.id}));
    const subcategories_opt = subcategories.filter(_i => _i.status == 1 && _i.category_id == category_id).map(_i => ({title: _i.name, value: _i.id}));

    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
              {/* <div className="row mb-5">
                <div className="col-xs-12 text-center word-wrap-break">
                  {formatMessage('frmMessageRecoveryQuestion')}
                </div>
              </div> */}
              <div className="row mb-5">
                <Field 
                  name='subject_id'
                  label={formatMessage('txtCaptionSubject')}
                  component={SelectFieldAnt}
                  validate={[required()]}
                  options={subject_opt}
                  onChange={(value) => {
                    this.props.change('subject_id', value);
                    this.props.change('category_id', '');
                    this.props.change('subcategory_id', '');
                  }}
                />
                <Field 
                  name='category_id'
                  label={formatMessage('txtCaptionCategory')}
                  component={SelectFieldAnt}
                  validate={[required()]}
                  options={categories_opt}
                  onChange={(value) => {
                    this.props.change('category_id', value);
                    this.props.change('subcategory_id', '');
                  }}
                />
                <Field 
                  name='subcategory_id'
                  label={formatMessage('txtCaptionSubjategory')}
                  component={SelectFieldAnt}
                  options={subcategories_opt}
                />
              </div>
              <div className="create-dialog-form__group flex">
                <button className="btn btn-primary mr-auto" type="submit">{formatMessage('btnModalRecovery')}</button>
                <button className="btn btn-warning" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalCancel')}</button>
              </div>
            </form>
          </div>
      </Modal>
    );
  }
}

RecoveryModal = reduxForm({
  form: 'recovery_question',
  enableReinitialize: true,
})(RecoveryModal);


const selector = formValueSelector('recovery_question')

const mapStateToProps = (state, ownProps) => ({
  subject_id: selector(state, 'subject_id'),
  category_id: selector(state, 'category_id')
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Trashed/components/RecoveryModal.jsx